export const autismBooks = [
  {
    title: "Unmasking Autism",
    author: "Devon Price",
    description: "A powerful look at masking in autistic individuals, with guidance on embracing authenticity and building a life rooted in self-acceptance.",
    link: "https://amzn.to/3VW3ypH",
    tags: ["Autistic Author", "Adult", "Self-Discovery", "Masking", "Authencity", "LGBTQ+"]
  },
  {
    title: "The Autistic Brain",
    author: "Temple Grandin",
    description: "Temple Grandin blends personal insight with neuroscience to explore how autism shapes thinking and behavior, offering practical strategies for understanding and thriving.",
    link: "https://amzn.to/4jZnNMA"
  },
  {
    title: "Sincerely Your Autistic Child",
    author: "Emily Paige",
    description: "A powerful collection of letters from autistic individuals to parents, offering guidance, encouragement, and honest reflections to foster deeper understanding and support for autistic children.",
    link: "https://amzn.to/3BBAP2P"
  },
  {
    title: "Square Me, Round World",
    author: "Chelsea Luker",
    description: "A poetic and introspective exploration of navigating an often overwhelming world as an autistic individual, offering unique perspectives and insights.",
    link: "https://amzn.to/3Pe3LB2"
  },

];
